<template>
<div v-if="!isShowViolation" style="height: 100vh;overflow: scroll;">
    <header>
        <span v-if="userInfo">{{ userInfo.display_name }}</span>
        <span v-else>
            <Skeletor width="100" /></span>
        <div class="h-left">
            <a @click="redirectBack"><img src="~@/assets/images/icon02.svg" /></a>
        </div>
        <div class="h-right">
            <a v-if="userInfo" @click="isShowPopup = true"><img src="~@/assets/images/icon06.svg" /></a>
            <span v-else>
                <Skeletor width="50" /></span>
        </div>
    </header>
    <div id="wrap" v-if="userInfo">
        <div id="fbt">
            <div class="fbt">
                <a v-if="parseInt(userInfo.sex) === FEMALE">
                    <div class="fbt03"><img @click="callAudio" src="~@/assets/images/fbt-iocn03.svg" /></div>
                </a>
                <a v-if="parseInt(userInfo.sex) === FEMALE">
                    <div class="fbt04"><img @click="callVideo" src="~@/assets/images/fbt-iocn04.svg" /></div>
                </a>

                <a @click="likeUser(userInfo.id, userInfo.is_like)" v-if="userInfo.is_like !== IS_LIKE && userInfo.is_like_back === IS_LIKE_BACK">
                    <div class="fbt05" style="width: 70%; left: 15%;">
                        <span class="white">マッチングする</span>
                    </div>
                </a>
                <a v-else-if="userInfo.is_matching === IS_MATCHING">
                    <div class="fbt05" style="width: 70%; left: 15%;">
                        <span class="white">メッセージを送る</span>
                    </div>
                </a>
                <a v-else>
                    <a @click="likeUser(userInfo.id, userInfo.is_like)" v-if="userInfo.is_like !== IS_LIKE && parseInt(userInfo.look_at_me_status) !== IS_LOOK_AT_ME">
                        <div class="fbt05">
                            <span class="white"><i class="fas fa-heart"></i> いいね</span>
                        </div>
                    </a>
                    <a @click="lookAtMe(userInfo.id)"
                        v-if="parseInt(userInfo.is_like) === IS_LIKE &&
                              parseInt(userInfo.look_at_me_status) !== IS_LOOK_AT_ME &&
                              parseInt(userInfo.first_message_status) === FIRST_MESSAGE_STATUS_NONE">

                        <div class="fbt05">
                            <span class="white">みてね！する</span>
                        </div>
                    </a>
                    <a v-if="parseInt(userInfo.look_at_me_status) === IS_LOOK_AT_ME || parseInt(userInfo.first_message_status) !== FIRST_MESSAGE_STATUS_NONE">
                        <div class="fbt05" style="background: #bdbdbd">
                            <span class="white">みてね！済み</span>
                        </div>
                        <div class="fbt06" style="background: #bdbdbd">
                            <span class="white">メッセージ&いいね済み</span>
                        </div>
                    </a>
                    <a v-if="parseInt(userInfo.look_at_me_status) !== IS_LOOK_AT_ME && parseInt(userInfo.first_message_status) == FIRST_MESSAGE_STATUS_NONE" @click="opendSendMessageLike(parseInt(userInfo.look_at_me_status), parseInt(userInfo.first_message_status))">
                        <div class="fbt06">
                            <span class="white"><i class="fas fa-comment-dots"></i> メッセージ＆いいね</span>
                        </div>
                    </a>
                </a>

            </div>
        </div>

        <div class="prof-ph">
            <p class="fav"><i @click="likeUser(userInfo.id, userInfo.is_like)" :class="userInfo.is_like === IS_LIKE || this.likeStatus ? 'fas fa-heart red' : 'fas fa-heart'"></i></p>
            <p class="prof-ph03">{{ userInfo.display_name }}</p>
            <p class="prof-ph04">
                <i :class="userInfo.is_private == 1 ? 'far fa-eye-slash grey' : ''"></i>
                <span style="white-space: pre;">{{ getLiving(userInfo.living_area_id) + " " }} {{userInfo.age}}歳 {{" " + getGender(userInfo.sex) }}</span>
                <i class="fas fa-heart red" style="margin-left: 7px;"></i> {{ userInfo.total_like }}いいね！
                <span v-if="parseInt(userInfo.sex) === FEMALE">
                    <i class="fas fa-phone pink"></i> 通話{{ getCallStatus(userInfo.enabled_call) }}
                    <span v-if="IS_WAITING_FOR_MEET === parseInt(userInfo.waiting_for_meet)"> <i class="fas fa-calendar-check pink2" style="margin-left: 7px;"></i> 本日OK </span>
                </span>
                <span style="margin-left: 7px;" v-if="parseInt(userInfo.sex) === MALE">
                    <i v-if="getFieldProfile('income', userInfo.income) != '未設定'" class="fas fa-coins yellow"></i> {{ getFieldProfile('income', userInfo.income) }}
                </span>
            </p>
            <div class="prof-bg"></div>
            <!-- <div id="main_avatar">
                <img :src="getImageUrl(userInfo.avatar_url)" @click="openAvatar()" />
            </div> -->
            <div v-if="getImage(userInfo.image)[0]">
                <div v-for="(item, index) in getImage(userInfo.image)" :id="'main_avatar_' + index" :key="index">
                    <img v-if="img_index === index" :src="getImageUrl(item.path)" @click="openAvatar()" />
                </div>
            </div>
            <div v-else>
                <img :src="getImageUrl(userInfo.avatar_url)"  @click="openAvatar()">
            </div>
            
        </div>

        <div class="prof-title">ひとこと</div>
        <div class="txt-area" style="padding: 16px 3%">
            <p v-if="userInfo.mood_status" style="margin-top: -5px">{{ userInfo.mood_status }}</p>

            <ul style="padding: 0" class="prof-ph02 clearfix images-container" id="ul_img">
                <li style="padding: 0" v-for="(item, index) in getImage(userInfo.image)" :key="index">
                    <span v-if="index == 0 ||
                        parseInt(item.view_status) === VIEW_STATUS_AVATAR_ALL || 
                        (userInfo.is_like === IS_LIKE && parseInt(item.view_status) === VIEW_STATUS_AVATAR_LIKE) ||
                        (userInfo.is_matching === IS_MATCHING && parseInt(item.view_status) === VIEW_STATUS_AVATAR_MATCHING)">
                        <img v-if="index == 0" :id="'img_' + index" :src="getImageUrl(item.path)" @click="showSubAvatar(index)" style="border: 2px solid salmon;box-sizing: border-box;"/>
                        <img v-else :id="'img_' + index" :src="getImageUrl(item.path)" @click="showSubAvatar(index)"/>
                    </span>
                    <span v-else>
                        <i class="fas fa-user-lock prof-lock"></i><img :src="getImageUrl(item.path)" class="blur" />
                    </span>
                </li>
            </ul>
        </div>

        <div class="prof-title">自己紹介</div>
        <div class="txt-area">
            <p v-html="userInfo.user_status">
            </p>
        </div>

        <div class="prof-title">詳細プロフィール</div>

        <div class="porf-area">
            <table>
                <tr>
                    <td>身長</td>
                    <td class="right">{{ getFieldProfile('height', userInfo.height) }}</td>
                </tr>
                <tr>
                    <td>体型</td>
                    <td class="right">{{ getFieldProfile('style', userInfo.style) }}</td>
                </tr>
                <tr>
                    <td>居住地</td>
                    <td class="right">{{ getFieldProfile('living_area', userInfo.living_area) }}</td>
                </tr>
                <tr>
                    <td>出身地</td>
                    <td class="right">{{ getFieldProfile('birth_place', userInfo.birth_place) }}</td>
                </tr>
                <tr>
                    <td>同居人</td>
                    <td class="right">{{ getFieldProfile('roommate', userInfo.roommate) }}</td>
                </tr>
                <tr>
                    <td>子供の有無</td>
                    <td class="right">{{ getFieldProfile('child', userInfo.child) }}</td>
                </tr>
                <tr>
                    <td>学歴</td>
                    <td class="right">{{ getFieldProfile('education', userInfo.education) }}</td>
                </tr>
                <tr>
                    <td>職業</td>
                    <td class="right">{{ getFieldProfile('job', userInfo.job) }}</td>
                </tr>
                <tr v-if="parseInt(userInfo.sex) === MALE">
                    <td>年収</td>
                    <td class="right">{{ getFieldProfile('income', userInfo.income) }}</td>
                </tr>
                <tr>
                    <td>休日</td>
                    <td class="right">{{ getFieldProfile('holidays', userInfo.holidays) }}</td>
                </tr>
                <tr>
                    <td>お酒</td>
                    <td class="right">{{ getFieldProfile('drinking', userInfo.drinking) }}</td>
                </tr>
                <tr>
                    <td>タバコ</td>
                    <td class="right">{{ getFieldProfile('smoking', userInfo.smoking) }}</td>
                </tr>
            </table>
        </div>

        <div class="prof-title">好きな事・趣味</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>{{ getYesNoDescribed(userInfo.hoppy) }}</td>
                </tr>
            </table>
        </div>
        <div class="prof-title">よく行く場所</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>{{ getYesNoDescribed(userInfo.favorite_pace) }}</td>
                </tr>
            </table>
        </div>
        <div class="prof-title">初デートで行きたい場所</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>{{ getYesNoDescribed(userInfo.first_place) }}</td>
                </tr>
            </table>
        </div>
        <div class="prof-title">出会うまでの希望</div>
        <div class="porf-area">
            <table>
                <tr>
                <td>{{ getFieldProfile('meeting_condition', userInfo.meeting_condition) }}</td>
                </tr>
            </table>
        </div>
        <div class="prof-title">会った時の希望</div>
        <div class="porf-area">
            <table>
                <tr>
                   <td>{{ getFieldProfile('purpose', userInfo.purpose) }}</td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
    </div>
    <div id="wrap" v-else>
        <div class="prof-ph">
            <p class="fav"><i class="fas fa-heart red"></i></p>
            <p class="prof-ph03">
                <Skeletor width="80" />
            </p>
            <p class="prof-ph04">
                <Skeletor width="50" />
                <Skeletor width="20" />歳
                <Skeletor width="20" />
                <i class="fas fa-heart red"></i>
                <Skeletor width="10" />いいね！
                <i class="fas fa-phone pink"></i> 通話
                <Skeletor width="10" />
                <Skeletor width="30" />
            </p>
            <div class="prof-bg"></div>
            <Skeletor height="380"></Skeletor>
        </div>

        <div class="prof-title">ひとこと</div>
        <div class="txt-area">
            <p>
                <Skeletor width="100" />
            </p>

            <ul class="prof-ph02 clearfix">
                <li v-for="item in 4" :key="item">
                    <Skeletor width="100%" />
                </li>
                <li>
                    <i class="fas fa-user-lock prof-lock"></i>
                    <Skeletor width="100%" />
                </li>
            </ul>
        </div>

        <div class="prof-title">自己紹介</div>
        <div class="txt-area">
            <p>
                <Skeletor width="100%" />
            </p>
        </div>

        <div class="prof-title">詳細プロフィール</div>

        <div class="porf-area">
            <table>
                <tr>
                    <td>身長</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>体型</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>居住地</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>出身地</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>同居人</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>子供の有無</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>学歴</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>職業</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>年収</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>休日</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>お酒</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
                <tr>
                    <td>タバコ</td>
                    <td class="right">
                        <Skeletor width="50" />
                    </td>
                </tr>
            </table>
        </div>

        <div class="prof-title">好きな事・趣味</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>
                        <Skeletor width="80" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="prof-title">よく行く場所</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>
                        <Skeletor width="80" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="prof-title">初デートで行きたい場所</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>
                        <Skeletor width="80" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="prof-title">出会うまでの希望</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>
                        <Skeletor width="80" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="prof-title">会った時の希望</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>
                        <Skeletor width="80" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="porf-area">
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
        </div>
    </div>
    <div style="height: 100px"></div>
</div>
<basic-dialog :active="isSendMessageLike">
    <div class="content-send-like-message">
        <p>メッセージを送りましょう！</p>
        <!-- Fix textarea placeholder for safari -->
        <div class="holder" style="padding: 0px; margin-top: 0px;">
            <div class="placeholder" id="placeholder_box" style="color: #7e7d7d; margin-top: 10px; margin-left: 1px;">
                お相手の共通点や気になったことを伝えてみましょう！<br>
                ※メッセージ付いいね！ではポイントが消費されます。<br>
                ※メールアドレスLINE ID・カカオID Facebookのアカウントやその他SNSのID、電話番号などあなたできる個人情報は送信できません。
            </div>
            <textarea id="msg_like_txtarea" v-model="contentMessageLike" :maxlength="msgMaxLength" @keyup="onPressTxt()"></textarea>
        </div>

        <p class="error">{{ validMessage }}</p>
        <p class="note">あと{{ contentMessageLike ? msgMaxLength - contentMessageLike.length : msgMaxLength }}文字</p>
        <div class="iine-btn1 submit" @click="submitSendMessageLike">
            <i class="fas fa-comment-dots"></i>メッセージ＆いいねする
        </div>
        <div class="iine-btn2 cancel" @click="closeSendMessageLike">
            キャンセル
        </div>
    </div>
</basic-dialog>
<imageShow :active="isShowImage">
    <div>
        <img :src="getPopupImage()" style="width: 100%;" id="popupImage">
    </div>
</imageShow>
<basic-dialog :active="isShowPopup">
    <div class="flex-row">
        <button class="btn-start" @click="favorite">
            {{ parseInt(userInfo.favorite_status) === IS_FAVORITE ? 'お気に入り解除' : 'お気に入りに追加' }}
        </button>
        <button class="btn-start-1" @click="isShowViolation = true; isShowPopup = false">
            違反報告する
        </button>
        <button class="btn-end" @click="lock">
            プロックする
        </button>
        <button class="btn-close" @click="isShowPopup = false">
            キャンセル
        </button>
    </div>
</basic-dialog>
<alertDialogBottom :active="isShowAlert">
     {{ messageAlert }}
</alertDialogBottom>
<!-- Subscription -->
<subscriptionAlert :active="isShowAlertSubscription">
    <div class="subscription">
        <div class="title">有料会員の登録が必要です</div>
        <div class="content">簡単ステップで<br>有料会員の登録を済ませましょう</div>
        <div class="btn1" @click="openSubscription()">詳しく見る</div>
    </div>
</subscriptionAlert>
<!-- Verify age -->
<subscriptionAlert :active="isShowAlertVerifyAge">
    <div class="subscription">
        <div class="title">年齢認証が必要です</div>
        <div class="content">
            <h3>簡単ステップで<br>年齢確認を済ませましょう。</h3>
            <br>
            お相手とのメッセージを行うためには<br>法令により年齢確認が必要となります。
        </div>
        <div class="btn1" @click="openVerifyAge()">詳しく見る</div>
    </div>
</subscriptionAlert>
<div id="subscription" class="hidden-right">
    <subscription :isShow="true" @close="closeSubscription"></subscription>
</div>
<div id="very-age" class="hidden-right">
    <veryAge :isShow="true" @close="closeVerifyAge"></veryAge>
</div>
<successDialog :active="isShowAlertProcessApprove" @close="isShowAlertProcessApprove = false">
    <template v-slot:message>
        <h3>現在年齢認証中です。</h3>
        <p>最大24時間かかります。</p>
    </template>
</successDialog>
<violation v-if="metadata && userInfo" :userDetail="userInfo" :isShow="isShowViolation" :report-categories="metadata.report_categories" @closeReport="closeReport"></violation>
</template>

<script>
import "vue-skeletor/dist/vue-skeletor.css";
import imageShow from "./components/imageShow"
import BasicDialog from "./components/basicDialog.vue";
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
import {
    Skeletor
} from 'vue-skeletor';
import {
    mapGetters
} from "vuex";
import mixin from '@/mixin'
import CONSTANTS from '@/constants'
import violation from './components/violation'
import subscriptionAlert from './components/subscriptionAlert.vue'
import subscription from '../profile/subscription'
import veryAge from '../profile/veryAge.vue'
import successDialog from '@/views/components/successDialog'
export default {
    name: "user detail",
    props: {
        idUser: {
            type: String,
            default: null
        },
    },
    emits: ['close'],
    components: {
        Skeletor,
        violation,
        imageShow,
        BasicDialog,
        alertDialogBottom,
        subscriptionAlert,
        subscription,
        veryAge,
        successDialog
    },
    mixins: [mixin],
    data: () => ({
        isShowViolation: false,
        userInfo: null,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        VIEW_STATUS_AVATAR_ALL: CONSTANTS.VIEW_STATUS_AVATAR_ALL,
        VIEW_STATUS_AVATAR_LIKE: CONSTANTS.VIEW_STATUS_AVATAR_LIKE,
        VIEW_STATUS_AVATAR_MATCHING: CONSTANTS.VIEW_STATUS_AVATAR_MATCHING,
        IS_MATCHING: CONSTANTS.IS_MATCHING,
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_LIKE_BACK: CONSTANTS.IS_LIKE_BACK,
        HOBBY_ON: CONSTANTS.HOBBY_ON,
        HOBBY_OFF: CONSTANTS.HOBBY_OFF,
        MALE: CONSTANTS.MALE,
        likeStatus: false,
        isShowImage: false,
        FEMALE: CONSTANTS.FEMALE,
        IS_LOOK_AT_ME: CONSTANTS.IS_LOOK_AT_ME,
        IS_ONLINE: CONSTANTS.IS_ONLINE,
        isSendMessageLike: false,
        contentMessageLike: '',
        validMessage: null,
        isValid: false,
        msgMaxLength: 200,
        FIRST_MESSAGE_STATUS_NONE: CONSTANTS.FIRST_MESSAGE_STATUS_NONE,
        FIRST_MESSAGE_STATUS_APPROVING: CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING,
        FIRST_MESSAGE_STATUS_APPROVED: CONSTANTS.FIRST_MESSAGE_STATUS_APPROVED,
        isShowPopup: false,
        // isFavoriteSuccess: false,
        // messageFavorite: null,
        IS_FAVORITE: CONSTANTS.IS_FAVORITE,
        // isLockSuccess: false,
        // messageLock: null,
        img_index: 0,
        isShowAlert: false,
        messageAlert: null,
        isShowAlertSubscription: false,
        isShowAlertVerifyAge: false,
        isShowAlertProcessApprove: false,
        pointSetting: null,
        // isShowSubscription: false
    }),
    mounted() {
        this.getUserInfo()
        this.getTemplateMessage()
        this.getPointFee()
        document.addEventListener("click", (evt) => {
            const flyoutElement = document.getElementsByClassName("subscription")[0];
            let targetElement = evt.target
            do {
                if (targetElement == flyoutElement) {
                    // console.log(flyoutElement)
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);
            const wrap = document.querySelector(".wrap");
            if (wrap == evt.target) {
                this.isShowAlertSubscription = false
                this.isShowAlertVerifyAge = false
            }
        });
        window.scrollTo(0, 0)
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken', "userDetail"]),
        userId() {
            if (this.idUser) {
                return this.idUser
            }
            return this.$route.query.id
        },
        page() {
            if (this.$route.query.page) {
                return this.$route.query.page
            }
            return null
        },
        type() {
            if (this.$route.query.type) {
                return this.$route.query.type
            }
            return null
        }
    },
    methods: {
        checkVery() {
            if (parseInt(this.userDetail.sex) === CONSTANTS.MALE &&
            parseInt(this.userDetail.is_subscription) === CONSTANTS.IS_SUBSCRIPTION && 
            parseInt(this.userDetail.is_verify_age) === CONSTANTS.IS_VERY_AGE) {
                return true
            }
            if (parseInt(this.userDetail.sex) === CONSTANTS.FEMALE &&
            parseInt(this.userDetail.is_verify_age) === CONSTANTS.IS_VERY_AGE) {
                return true
            }
            return false
        },
        redirectVery() {
            let userDetail = this.userDetail
            if (userDetail && parseInt(userDetail.is_subscription) !== CONSTANTS.IS_SUBSCRIPTION && parseInt(userDetail.sex) === CONSTANTS.MALE) {
                this.isShowAlertSubscription = true
                return
            }
            if (userDetail && parseInt(userDetail.is_verify_age) === CONSTANTS.NO_VERY_AGE) {
                this.isShowAlertVerifyAge = true
                return
            }
            if (userDetail && parseInt(userDetail.is_verify_age) === CONSTANTS.PC_VERY_AGE) {
                this.isShowAlertProcessApprove = true
                return
            }

        },
        callAudio() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            this.$store.dispatch('call/call_audio', {r_id: this.idUser, pointSetting: this.pointSetting, avatar_url:this.getImageUrl(this.userInfo.avatar_url)})

        },
        callVideo() {
            if (!this.checkVery()) {
                this.redirectVery()
                return
            }
            this.$store.dispatch('call/call_video', {r_id: this.idUser, pointSetting: this.pointSetting, avatar_url:this.getImageUrl(this.userInfo.avatar_url)})
        },
        async getPointFee() {
            this.$store
                .dispatch("user/getPointFee", {
                    token: this.defaultToken,
                })
                .then((data) => {
                    this.pointSetting = data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        closeSubscription() {
            document.getElementById('subscription').classList.remove('show-right')
            document.getElementById('subscription').classList.add('hidden-right')
        },
        openSubscription() {
            this.isShowAlertSubscription = false
            document.getElementById('subscription').classList.add('show-right')
            document.getElementById('subscription').classList.remove('hidden-right')
        },
        openVerifyAge() {
            this.isShowAlertVerifyAge = false
            document.getElementById('very-age').classList.add('show-right')
            document.getElementById('very-age').classList.remove('hidden-right')
        },
        closeVerifyAge(val) {
            if (val) {
                this.userDetail.is_verify_age = CONSTANTS.PC_VERY_AGE
            }
            document.getElementById('very-age').classList.remove('show-right')
            document.getElementById('very-age').classList.add('hidden-right')
        },
        redirectBack() {
            if (this.idUser) {
                this.$emit('close', this.likeStatus)
                return
            }
            if (this.page === 'like') {
                this.$router.push({name: 'like', query:{type: this.type}})
            } else {
                this.$router.go(-1)
            }
            
        },
        closeReport() {
            this.isShowViolation = false
        },
        showSubAvatar(index) {
            this.img_index = index;
            let ul_img = document.getElementById('ul_img').getElementsByTagName('img');
            for (var i = 0; i < ul_img.length; i++) {
                ul_img[i].style = '';
            }

            document.getElementById('img_' + index).style = "border: 2px solid salmon;box-sizing: border-box;";
        },
        getPopupImage() {
            if (this.img_index == 0) {
                return this.getImageUrl(this.userInfo.avatar_url);
            } else {
                return this.getImageUrl(document.getElementById('main_avatar_' + this.img_index).getElementsByTagName('img')[0].src);
            }
        },
        openAvatar() {
            this.isShowImage = true
            document.addEventListener("click", (evt) => {
                const flyoutElement = document.getElementById("popupImage");
                let targetElement = evt.target; // clicked element
                do {
                    if (targetElement == flyoutElement) {

                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                    // targetElement.getElementsByTagName('img')[0].src = document.getElementById('main_avatar').getElementsByTagName('img')[0].src;
                } while (targetElement);
                const wrap = document.querySelector(".wrap");
                if (wrap == evt.target) {
                    this.isShowImage = false
                }
                // This is a click outside.

            });
        },
        lookAtMe(id) {
            let formData = new FormData()
            formData.append('token', this.defaultToken)
            formData.append('user_look_at_id', id)
            formData.append('message', CONSTANTS.MESSAGE_LOOK_AT_ME)
            this.$store.dispatch('like/lookAtMe', formData).then((data) => {
                this.userInfo.look_at_me_status = CONSTANTS.IS_LOOK_AT_ME
                this.messageAlert = "みてねを送りました。"
                this.isShowAlert = true
                setTimeout(() => {
                    this.isShowAlert = false
                }, 1000)
            }).catch(err => {
                console.log(err)
            })
        },
        openViolation() {
            this.isShowViolation = true
        },
        getImage(images) {
            if (images) {
                let imgs = JSON.parse(images)
                if (imgs[0]) {
                    imgs = imgs.filter(item => {
                        // Hung update: set "item.image_index == 0" to show main avatar even if don't have main avatar
                        return (item.is_approve === 0 && !item.path.includes(CONSTANTS.URL_DEFAULT)) || item.image_index == 0
                    })
                }
                return imgs
            }
        },
        getUserInfo() {
            this.$store.dispatch('user/userShow', {
                id: this.userId,
                token: this.defaultToken
            }).then(data => {
                this.userInfo = data
                // console.log('userInfo: ', this.userInfo)
            }).catch(err => {
                console.log(err)
            })
        },
        getLiving(id) {
            if (!this.metadata) return null
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.field_id === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return null;
        },

        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        likeUser(id, isLike) {
            if (isLike !== CONSTANTS.IS_LIKE) {
                let formData = new FormData();
                formData.append("type", 0);
                // formData.append("token", this.token);
                formData.append("user_like_id", id);
                this.$store
                    .dispatch("user/likeUser", formData)
                    .then(() => {
                        this.likeStatus = true
                        this.userInfo.is_like = CONSTANTS.IS_LIKE;
                        this.messageAlert = "いいねを送りました。"
                        this.isShowAlert = true
                        setTimeout(() => {
                            this.isShowAlert = false
                        }, 1000)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        opendSendMessageLike(lookAt, first_message_status) {
            if (lookAt !== CONSTANTS.IS_LOOK_AT_ME && first_message_status !== CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING) {
                if (parseInt(this.userDetail.is_subscription) !== CONSTANTS.IS_SUBSCRIPTION && parseInt(this.userDetail.sex) === CONSTANTS.MALE) {
                    this.isShowAlertSubscription = true
                    return
                }
                if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.NO_VERY_AGE) {
                    this.isShowAlertVerifyAge = true
                    return
                }
                if (parseInt(this.userDetail.is_verify_age) === CONSTANTS.PC_VERY_AGE) {
                    this.isShowAlertProcessApprove = true
                    return
                }
                this.isSendMessageLike = true
                setTimeout(() => {
                    if (this.contentMessageLike.length <= 0) {
                        document.getElementById('msg_like_txtarea').value = '';
                    } else {
                        document.getElementById('placeholder_box').style.display = 'none';
                    }
                }, 1)
            }
        },
        
        submitSendMessageLike() {
            if (this.contentMessageLike.length < 10) {
                this.isValid = true
                this.validMessage = "10文字以上を入カしてください"
            } else {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("type", 0)
                formData.append("user_like_id", this.userId)
                formData.append("message", this.contentMessageLike)
                this.$store
                    .dispatch("profile/sendLikeMessage", formData)
                    .then((data) => {
                        this.pageCurrent = 1
                        this.userInfo.first_message_status = CONSTANTS.FIRST_MESSAGE_STATUS_APPROVING
                        this.closeSendMessageLike()
                        this.messageAlert = "メッセージ付きいいねを送りました。"
                        this.isShowAlert = true
                        setTimeout(() => {
                            this.isShowAlert = false
                        }, 1000)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        closeSendMessageLike() {
            this.isSendMessageLike = false;
            document.querySelector("textarea").setAttribute("disabled", false);
            this.isValid = false;
            this.validMessage = null;
            this.contentMessageLike = '';
        },
        getTemplateMessage() {
            this.$store
                .dispatch("message/getMessageTemplate", {
                    token: this.defaultToken,
                })
                .then((data) => {
                    if (data[0]) {
                        // status = 1: message template ON, status = 0: message template off
                        this.contentMessageLike = data[0].status == 1 ? data[0].body : '';
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async favorite() {
            this.messageAlert = null
            let type = null
            if (parseInt(this.userInfo.favorite_status) === CONSTANTS.IS_FAVORITE) {
                type = CONSTANTS.UN_FAVORITES_STATUS
            } else {
                type = CONSTANTS.FAVORITES_STATUS
            }
            // simulate AJAX

            if (type === CONSTANTS.UN_FAVORITES_STATUS) {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("user_id", this.userId)
                await this.$store
                    .dispatch("user/sendUnFavorite", formData)
                    .then(() => {
                        this.isShowAlert = true
                        this.isShowPopup = false
                        this.userInfo.favorite_status = type
                        if (type === CONSTANTS.UN_FAVORITES_STATUS) {
                            this.messageAlert = "お気に入りを解除しました"
                        } else {
                            this.messageAlert = "お気に入りに追加しました"
                        }
                        setTimeout(() => {
                            this.isShowAlert = false
                        }, 1000)
                    })
                    .catch((err) => {
                        this.isShowPopup = false
                        console.log(err);
                    });
            } else {
                let formData = new FormData()
                formData.append("token", this.defaultToken)
                formData.append("favorites_user_code", this.userInfo.user_code)
                formData.append("favorites_id", this.userId)
                formData.append("type", type)

                await this.$store
                    .dispatch("user/sendFavorite", formData)
                    .then(() => {
                        this.isShowAlert = true
                        this.isShowPopup = false
                        this.userInfo.favorite_status = type
                        if (type === CONSTANTS.UN_FAVORITES_STATUS) {
                            this.messageAlert = "お気に入りを解除しました"
                        } else {
                            this.messageAlert = "お気に入りに追加しました"
                        }
                        setTimeout(() => {
                            this.isShowAlert = false
                        }, 1000)
                    })
                    .catch((err) => {
                        this.isShowPopup = false
                        console.log(err);
                    });
            }

        },

        async lock() {
            this.messageAlert = null
            let formData = new FormData()
            formData.append("token", this.defaultToken)
            formData.append("id", this.userId)
            formData.append('lock_user_code', this.userInfo.user_code)
            formData.append('type', CONSTANTS.LOCK_STATUS)
            await this.$store
                .dispatch("user/lockUser", formData)
                .then(() => {
                    this.isShowAlert = true
                    this.isShowPopup = false
                    this.messageAlert = "ブロックしました。"
                    setTimeout(() => {
                        this.isShowAlert = false
                    }, 1000)
                })
                .catch((err) => {
                    this.isShowPopup = false
                    console.log(err);
                });
        },

        onPressTxt() {
            if (this.contentMessageLike.length > 0) {
                document.getElementById('placeholder_box').style.display = 'none';
            } else {
                document.getElementById('placeholder_box').style.display = 'block';
            }
        },

    }
}
</script>

<style scoped>
.iine-btn2 {
    font-size: 12px;
}

.content-send-like-message {
    background: #ffff;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.content-send-like-message textarea {
    width: 99%;
    height: 150px;
    margin-top: 15px;
}

.content-send-like-message div {
    margin: 5px;
    padding: 2px;
    color: #fff;
}

.content-send-like-message div.cancel {
    width: 50%;
}

.content-send-like-message div.submit {
    width: 80%;
}

.content-send-like-message p {
    margin: 5px;
}

.content-send-like-message .error {
    height: 10px;
    color: red;
    font-size: 10px;
    text-align: left;
    width: 100%;
}

.content-send-like-message p.note {
    width: 100%;
    text-align: right;
    background: none;
    padding: 0px;
    font-size: 10px;
}

.flex-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.flex-row button {
    outline: none;
    border: none;
    color: #4a87fb;
    width: 100%;
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid #e1e1e1;
}

.flex-row button.btn-start {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.flex-row button.btn-end {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.flex-row button.btn-close {
    margin-top: 15px;
    border-radius: 5px;
}

.favorite-message {
    color: #777;
    background: #fff;
    border-radius: 5px;
    padding: 5px;
}
.subscription {
    background: #fff;
    padding-bottom: 10px;
}
.subscription .content {
    padding: 20px;
}
.subscription .btn1 {
    color: #fff;
    padding: 10px;
}
.hidden-right {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    overflow: hidden;
}
.show-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    z-index: 999999;
    background: #fff;
    overflow: scroll;
    height: 100vh;
}
#subscription, #very-age {
    transition: all 0.2s;
}
.images-container{
    display: -webkit-box;
    overflow: auto;
}

.holder {
    width: 100%;
    position: relative;
}
.placeholder {
    pointer-events: none;
    position: absolute;
    text-align: left;
    font-size: 10.7px;
}

</style>
